import { getArgs } from "../utils";
import api from "./api";

const route = "/users";

const CustomerService = {
  getCustomer: (customer_id) => api.get(`${route}/admin/${customer_id}`),
  getAllCustomers: (filters) =>
    api.get(`${route}/admin/all?${getArgs(filters)}`),
  getCustomersByQuery: (query) => api.get(`${route}/query?query=${query}`),
  getCourseCustomers: (course_id) =>
    api.get(`${route}/admin/course/${course_id}`),
  postCustomer: (customer) => api.post(route, { ...customer }),
  putCustomer: (customer) => api.put(route, { ...customer }),
  putCurrentCustomer: (customer) => api.put(route, { ...customer }),
  extenderAcceso: (
    user_id,
    course_id,
    expiration_days,
    is_gift,
    payment_method_id
  ) =>
    api.post(`${route}/giveAccess`, {
      user_id,
      course_id,
      expiration_days,
      is_gift,
      payment_method_id,
    }),
  giveClasses: (customer_id, amount, expiration_days) =>
    api.put(`${route}/giveClasses`, {
      customer_id,
      amount,
      expiration_days,
    }),
  revokeAccess: (purchase_id) =>
    api.put(`${route}/revokeAccess`, { purchase_id }),
  removeClasses: (customer_id, amount) =>
    api.put(`${route}/removeClasses`, { customer_id, amount }),
  recoverPassword: (email) => api.post(`${route}/recover`, { email }),
  deleteCustomer: (customer_id) => api.delete(`${route}/${customer_id}`),
  getPasswordResetLink: (email) =>
    api.post(`${route}/resetPasswordLink`, { email }),
};

export default CustomerService;
